import type { MapaCargo } from '@/components/Configuracao/mapaCargos/mapaCargosTypes'

export const CARGO_ANALISTA_DE_TRAFEGO_PAGO: MapaCargo = 
{
  id: 'analista-de-trafego-pago',
  titulo: 'Analista de Tráfego Pago',
  setor: 'Performance',
  secoes: [
    {
      id: 'execucao-de-campanhas-de-trafego-pago',
      titulo: 'Execução de Campanhas de Tráfego Pago',
      atividades: [
        'Planejar, estruturar e executar campanhas de tráfego pago em plataformas como Google Ads, Meta Ads (Facebook e Instagram), TikTok Ads, LinkedIn Ads, Pinterest Ads, entre outras.',
        'Configurar campanhas com definição de objetivos, estrutura de campanhas e grupos de anúncios, segmentações, públicos, formatos e carregamento de criativos.',
        'Definir e ajustar parâmetros técnicos das campanhas, como orçamento, estratégias de lance, posicionamentos e eventos de conversão.',
        'Gerenciar anúncios ativos, garantindo que criativos, públicos e configurações estejam corretamente implementados nas plataformas.',
      ],
    },
    {
      id: 'monitoramento-de-desempenho',
      titulo: 'Monitoramento de Desempenho',
      atividades: [
        'Realizar acompanhamento diário das campanhas para garantir que os anúncios estejam rodando corretamente e sem problemas técnicos.',
        'Monitorar métricas de desempenho como CPC, CTR, CPM, CPA, ROAS e taxa de conversão.',
        'Identificar rapidamente falhas de entrega, problemas técnicos ou inconsistências nos resultados e realizar os ajustes necessários.',
        'Aplicar ajustes rápidos de orçamento e lances com base no desempenho das campanhas.',
      ],
    },
    {
      id: 'otimizacao-de-campanhas',
      titulo: 'Otimização de Campanhas',
      atividades: [
        'Realizar otimizações contínuas nas campanhas com base em dados de performance.',
        'Ajustar criativos, segmentações, formatos e estrutura das campanhas para melhorar os resultados.',
        'Realizar testes e revisões constantes dos anúncios para aumentar eficiência e performance.',
        'Solicitar ajustes criativos ou estratégicos quando necessário com base nas métricas de desempenho.',
      ],
    },
    {
      id: 'gerenciamento-de-segmentacoes-e-publicos',
      titulo: 'Gerenciamento de Segmentações e Públicos',
      atividades: [
        'Estruturar e gerenciar públicos e segmentações de acordo com a estratégia definida.',
        'Garantir que os anúncios estejam direcionados corretamente ao público-alvo durante toda a execução das campanhas.',
        'Corrigir possíveis erros de segmentação ou falhas de configuração que impactem a entrega dos anúncios.',
      ],
    },
    {
      id: 'acompanhamento-das-ferramentas-de-anuncios-mensuracao-e-perf',
      titulo: 'Acompanhamento das Ferramentas de Anúncios, mensuração e performance',
      atividades: [
        'Operar diariamente as plataformas de anúncios, garantindo o funcionamento correto das campanhas.',
        'Monitorar recursos de automação e otimização das plataformas para garantir melhor performance.',
        'Acompanhar e validar configurações de mensuração como pixels, tags, eventos, conversões e UTMs por meio de ferramentas como Google Tag Manager, GA4, Meta Events Manager e plataformas de anúncios.',
        'Apoiar o time e os clientes em demandas relacionadas a ferramentas que impactem a performance, incluindo CRM, automação, formulários, páginas de destino, integrações e recebimento de leads.',
        'Identificar, sinalizar e acompanhar problemas técnicos que possam comprometer a mensuração, a captação de leads, a análise de dados ou o desempenho das campanhas.',
        'Quando a solução depender de outras áreas, clientes ou fornecedores, orientar e apoiar o encaminhamento da demanda até sua resolução.',
      ],
    },
    {
      id: 'gestao-de-orcamentos-e-performance',
      titulo: 'Gestão de orçamentos e performance',
      atividades: [
        'Controlar investimentos em mídia paga, garantindo a melhor distribuição de orçamento entre campanhas, públicos e canais.',
        'Otimizar campanhas com foco em eficiência de investimento e maximização de resultados, especialmente ROAS e custo por aquisição.',
      ],
    },
    {
      id: 'relatorios-e-analise-de-resultados',
      titulo: 'Relatórios e Análise de Resultados',
      atividades: [
        'Criar e atualizar dashboards e relatórios de performance em ferramentas como Looker Studio e outras plataformas de análise.',
        'Transformar dados de campanhas em insights estratégicos para apoiar tomadas de decisão.',
      ],
    },
    {
      id: 'integracao-com-equipes-de-marketing-e-criacao',
      titulo: 'Integração com Equipes de Marketing e Criação',
      atividades: [
        'Trabalhar em conjunto com equipes de marketing, planejamento, criação e vendas para garantir alinhamento estratégico das campanhas.',
        'Colaborar com o time criativo para garantir qualidade e consistência dos anúncios utilizados nas campanhas.',
        'Apoiar o time interno em dúvidas e demandas relacionadas à performance digital, ferramentas de tráfego, mensuração, CRM e acompanhamento de resultados.',
        'Manter postura colaborativa, proativa e orientada à solução, contribuindo para o bom andamento das demandas junto ao time e aos clientes.',
      ],
    },
  ],
}
